var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-parent-container"},[_c('div',{class:['loading', { fixed: _vm.fixed }]},[(_vm.showLoadingTextWithLoader)?_c('div',{staticClass:"loading-text"},[_vm._v(" "+_vm._s(_vm.$t("widgetApp.loading"))+"... ")]):_vm._e()])])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }